import axios from 'axios'

import { handleErrorAndGenerateMessage } from '../../../functions/errorHandling'
import { getServerUrl } from '../../../functions/getServerUrl'

const defaultState = {
  fetchingNotifications: false,
  notifications: [],
  unreadNotifications: 0,
  currentNotification: null,
}

export default function notificationsReducer(state = defaultState, action) {
  switch (action.type) {
    case "FETCHING_NOTIFICATIONS":
      return { ...state, fetchingNotifications: true }
    case "SET_NOTIFICATIONS":
      return {
        ...state,
        fetchingNotifications: false,
        notifications: action.payload.notifications,
        unreadNotifications: action.payload.unreadNotifications,
      }
    case "SET_CURRENT_NOTIFICATION":
      return { ...state, ...action.payload }
    case "DELETE_NOTIFICATION":
      return { ...state, ...action.payload }
    case "UPDATE_NOTIFICATIONS":
      return { ...state, notifications: action.payload }
    case "MARK_ALL_NOTIFICATIONS_AS_READ":
      const readNotifications = state.notifications.map(notification => {
        return { ...notification, is_read: true }
      })

      return { ...state, notifications: readNotifications, unreadNotifications: 0 }
    case "DELETE_UNPINNED_NOTIFICATIONS":
      const pinnedNotifications = state.notifications.filter(note => note.is_pinned)
      return {
        ...state,
        notifications: pinnedNotifications,
        currentNotification: state.currentNotification?.is_pinned ? state.currentNotification : null,
        unreadNotifications: 0
      }
    default:
      return state
  }
}

const fetchingNotification = () => {
  return { type: "FETCHING_NOTIFICATIONS" }
}

const setNotifications = (notifications) => {
  const unreadNotifications = notifications.filter(notification => notification.is_read === false).length
  return { type: "SET_NOTIFICATIONS", payload: { notifications, unreadNotifications}}
}

export const getNotifications = (props) => {
  return (dispatch) => {
    dispatch(fetchingNotification())
    axios({
      method: 'GET',
      url: `${getServerUrl()}/notifications/`,
      headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
    })
    .then(response => {
      dispatch(setNotifications(response.data))
    })
    .catch(error => {
      const message = handleErrorAndGenerateMessage(error, 'retrieving your notifications from the server', dispatch)
      if (props && props.alert && props.alert.show) {
        props.alert.show(message)
      }
    })
  }
}

const findAndUpdateNotification = (notification, allNotifications) => {
  const index = allNotifications.findIndex(n => n.url === notification.url)

  const updatedNotifications = [
    ...allNotifications.slice(0, index),
    notification,
    ...allNotifications.slice(index + 1),
  ]

  return updatedNotifications
}

export const setCurrentNotification = (notification, props) => {
  return (dispatch) => {
    const currentNotification = { ...notification, is_read: true }
    let { notifications, unreadNotifications } = props

    if (notification.is_read === false) {
      unreadNotifications = props.unreadNotifications - 1

      notifications = findAndUpdateNotification(currentNotification, props.notifications)

      dispatch(toggleNotificationRead(notification, true, props))
    }

    const payload = {
      notifications,
      currentNotification,
      unreadNotifications,
    }


    return dispatch({ type: 'SET_CURRENT_NOTIFICATION', payload })
  }
}

export const toggleNotificationRead = (notification, is_read, props) => {
  return (dispatch) => {
    axios({
      method: 'PATCH',
      url: notification.url,
      data: { is_read },
      headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
    })
    .then(response => {

    })
    .catch(error => {
      const message = handleErrorAndGenerateMessage(error, 'updating the notification', dispatch)
      if (props && props.alert && props.alert.show) {
        props.alert.show(message)
      }
    })
  }
}

export const togglePinNotification = (notification, is_pinned, props) => {
  return (dispatch) => {
    axios({
      method: 'PATCH',
      url: notification.url,
      data: { is_pinned },
      headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
    })
    .then(response => {
      dispatch(setCurrentNotification(response.data, props))
      return dispatch(updateNotification(response.data, props.notifications))
    })
    .catch(error => {
      const message = handleErrorAndGenerateMessage(error, 'pinning the notification', dispatch)
      if (props && props.alert && props.alert.show) {
        props.alert.show(message)
      }
    })
  }
}

const updateNotification = (notification, allNotifications) => {
  const notifications = findAndUpdateNotification(notification, allNotifications)
  return { type: "UPDATE_NOTIFICATIONS", payload: notifications }
}

export const markAllNotificationsAsRead = (props) => {
  return (dispatch) => {
    axios({
      method: 'PATCH',
      url: `${getServerUrl()}/notifications/mark_all_read/`,
      headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
    })
    .then(response => {
      return dispatch({ type: "MARK_ALL_NOTIFICATIONS_AS_READ" })
    })
    .catch(error => {
      const message = handleErrorAndGenerateMessage(error, 'marking your notifications as read', dispatch)
      if (props && props.alert && props.alert.show) {
        props.alert.show(message)
      }
    })
  }
}

export const deleteUnpinnedNotifications = (props) => {
  return (dispatch) => {
    axios({
      method: 'DELETE',
      url: `${getServerUrl()}/notifications/delete_unpinned/`,
      headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
    })
    .then(response => {
      return dispatch({ type: "DELETE_UNPINNED_NOTIFICATIONS" })
    })
    .catch(error => {
      const message = handleErrorAndGenerateMessage(error, 'deleting your unpinned notifications', dispatch)
      if (props && props.alert && props.alert.show) {
        props.alert.show(message)
      }
    })
  }
}

export const deleteNotification = (notification, props) => {
  return (dispatch) => {
    axios({
      method: 'DELETE',
      url: notification.url,
      headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
    })
    .then(response => {
      const notifications = props.notifications.filter(note => note.url !== notification.url)
      const payload = { notifications, currentNotification: null }
      return dispatch({ type: "DELETE_NOTIFICATION", payload })
    })
    .catch(error => {
      const message = handleErrorAndGenerateMessage(error, 'deleting your notification', dispatch)
      if (props && props.alert && props.alert.show) {
        props.alert.show(message)
      }
    })
  }
}
